import CardTravelIcon from '@mui/icons-material/CardTravel';
import { useNavigate } from 'react-router-dom';
import { SystemScreen } from '../../components/alliance/system-screen';

/** A trip code that doesn't match a published trip */
export function TripNotFound() {
  // Hooks
  const navigate = useNavigate();

  return (
    <SystemScreen
      layout="inline"
      tone="neutral"
      icon={<CardTravelIcon />}
      eyebrow="Trip not found"
      title="This trip could not be found"
      body={<p>The link may be out of date, or the trip may have ended.</p>}
      primaryAction={{
        label: 'View upcoming trips',
        onClick: () => navigate('/trips'),
      }}
    />
  );
}
